function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.998 22.435a.5.5 0 01-.359-.152l-9.8-10.091A6.139 6.139 0 01.665 5.01a6.345 6.345 0 0110.084-1.617l1.249 1.139 1.263-1.152a6.281 6.281 0 014.43-1.806c1.716 0 3.322.672 4.522 1.891a6.149 6.149 0 01-.065 8.735l-9.791 10.083a.507.507 0 01-.359.152zM6.31 2.571a5.326 5.326 0 00-4.755 2.893 5.145 5.145 0 00.993 6.021l9.45 9.731 9.441-9.723a5.156 5.156 0 001-6.033 5.339 5.339 0 00-.939-1.294 5.298 5.298 0 00-3.807-1.592 5.307 5.307 0 00-3.745 1.531l-1.614 1.472a.5.5 0 01-.674 0l-1.6-1.459a5.355 5.355 0 00-3.75-1.547z"
});

function SvgHeart(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "heart.d4e98.svg";
export { SvgHeart as ReactComponent };